import { makeStyles } from 'makeStyles';
import { STATUS_RED } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  loading: {
    display: 'flex',
    margin: 'auto',
  },
  amountToPay: {
    color: STATUS_RED,
  },
  warningBox: {
    width: '100%',
    marginLeft: theme.spacing(2),
  },
}));
